
import {postSupportUpdateStatus} from '../api/postSupportUpdateStatus';

const setPostSupportUpdateStatus = (params) => {
    return async (dispatch, getState) => {
        try {
            await postSupportUpdateStatus(params);
     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostSupportUpdateStatus
}